import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';

import isFunction from 'Lib/utilities/isFunction';

import PromptModal from '../modals/PromptModal';

const MoreOptions = ({ disabled, header, options, variant = '' }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [option, setOption] = useState({});
    const history = useHistory();

    useEffect(() => {
        return () => setDeleteModalOpen(false);
    }, []);

    const toggleMenu = event => {
        event.stopPropagation();
        setAnchorEl(prev => (prev ? null : event.currentTarget));
    };

    const onClick = (event, option) => {
        toggleMenu(event);

        if (option.onDelete) {
            setDeleteModalOpen(true);
            setOption(option);
        }

        if (option.to) {
            option.newWindow ? window.open(option.to, '_blank') : history.push(option.to);
        }

        option.onClick?.();
    };

    const onDelete = prompt => {
        prompt.setProcessing(true);
        option
            .onDelete()
            .then(() => {
                prompt.setProcessing(false);
                setDeleteModalOpen(false);
            })
            .catch(() => prompt.setProcessing(false));
    };

    const renderDeleteModal = () => (
        <PromptModal
            {...option}
            isOpen={deleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            header={option.deleteModalHeader}
            body={option.deleteModalBody}
            buttons={prompt => {
                if (prompt.isProcessing) {
                    return (
                        <Button color="danger" disabled={true}>
                            {option.button?.action || 'Deleting'}
                        </Button>
                    );
                }

                return (
                    <>
                        <Button color="danger" disabled={prompt.isDisabled} onClick={() => onDelete(prompt)}>
                            {option.button?.text || 'Delete'}
                        </Button>
                        <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
                            Cancel
                        </Button>
                    </>
                );
            }}
        />
    );

    const optionList = isFunction(options) ? options() : options;

    if (!optionList || optionList.length === 0) return null;

    return (
        <Box sx={{ float: 'right' }}>
            <IconButton variant={variant} id="more-options" disabled={disabled} aria-haspopup="true" onClick={toggleMenu}>
                more_vert
            </IconButton>
            <Menu id="more-options-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={toggleMenu} MenuListProps={{ 'aria-labelledby': 'more-options-button' }}>
                {header && <MenuItem>{header}</MenuItem>}
                {optionList.map((option, index) => (
                    <MenuItem key={index} onClick={e => onClick(e, option)} sx={{ color: option.color === 'danger' ? 'error.main' : 'common.black' }}>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
            {renderDeleteModal()}
        </Box>
    );
};

export default MoreOptions;
